import { Route, Routes } from 'react-router-dom';
import './App.css'; 
import Com from './Pages/Common/Com';
import User from './Pages/Common/Side_Bar/User';
import File from './Pages/Common/Side_Bar/File';
import Analytis from './Pages/Common/Side_Bar/Analytis'
import Settings from './Pages/Common/Side_Bar/Settings'
import Saved from './Pages/Common/Side_Bar/Saved'
import Order from './Pages/Common/Side_Bar/Order'
import Messages from './Pages/Common/Side_Bar/Messages'
import Home from './Pages/Home/Home/Home'; 

//              

function App() {
  return (
    <div className="App">
      <Home />
      {/* <Com>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/users" element={<User/>} />
          <Route path="/fil-manager" element={<File/>} />
          <Route path="/analytics" element={<Analytis />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/saved" element={<Saved />} />
          <Route path="/order" element={<Order />} />
          <Route path="/messages" element={<Messages />} />
        </Routes>
      </Com> */}
    </div>
  );
} 
export default App;
